import React from "react";
import PageHeader from "../../components/PageHeader";
import AppUserCreateComponent from "../../components/AppUsers/AppUserCreate";

class AppUserCreate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="AppUser Create"
                            Breadcrumb={[
                                { name: "Users", navigate: "/app-users" },
                                { name: "User Create", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <AppUserCreateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AppUserCreate;
